import { Globals } from "../../classes/Globals";
import { HTMLController } from "../../classes/mvc/HTML/HTMLController";
import { modules } from "../../main";
import { ModelNumberInput } from "./ModelNumberInput";

declare const currentPageSite:string;
declare const sWaehrnam:string;
declare let basketResponse:any;

export class ControllerNumberInput extends HTMLController<ModelNumberInput> {

    private static DEFAULT_MAX: number = 100;
    private static DEFAULT_MIN: number = 1;
    private static DEFAULT_STEP: number = 1;
    private static OVERRIDE_MIN: boolean = false;

    // private input: JQuery<HTMLInputElement>;

    private max: number;
    private min: number;
    private step: number;

    private inputField:HTMLInputElement;
    private fieldsMengeEle: HTMLDivElement;

    private plusInterval: any;
    private minusInterval: any;

    private timeoutTimer: any;

    public constructor( accessName: string, accessID: number, element: JQuery<HTMLElement> ) {
        super( new ModelNumberInput(), accessName, accessID, element );

        this.fieldsMengeEle = element[0] as HTMLDivElement;
        this.plusInterval = 0;
        this.minusInterval = 0;
    }

    public initGlobals(): void {
        let defaultMax = Number( this.getModule().getConfig( "default_max" ) );
        let defaultMin = Number( this.getModule().getConfig( "default_min" ) );
        let defaultStep = Number( this.getModule().getConfig( "default_step" ) );
        let overrideMin = this.getModule().getConfig( "override_min" );

        if ( !isNaN( defaultMax ) ) { ControllerNumberInput.DEFAULT_MAX = defaultMax; }
        if ( !isNaN( defaultMin ) ) { ControllerNumberInput.DEFAULT_MIN = defaultMin; }
        if ( !isNaN( defaultStep ) ) { ControllerNumberInput.DEFAULT_STEP = defaultStep; }
        if ( overrideMin ) { ControllerNumberInput.OVERRIDE_MIN = overrideMin }
    }

    public run(): void {
        if ( ! this.fieldsMengeEle ) return null;
        const plusButton:HTMLSpanElement = this.fieldsMengeEle.querySelector('[data-ez-item="plus"]');
        const minusButton:HTMLSpanElement = this.fieldsMengeEle.querySelector('[data-ez-item="minus"]');
        this.inputField = this.fieldsMengeEle.querySelector('[data-ez-item="field"]');

        if ( ! plusButton || ! minusButton || ! this.inputField )
            this.getModule().error( Globals.MODULE_LOADING_ERROR + " nicht alle der folgenden Items gefunden wurde: plus, minus oder field" );
        const max: string = this.getParam( "max" );
        const min: string = this.getParam( "min" );
        const step: string = this.getParam( "step" );
        const inputeValue: string = String( this.inputField.value );

        this.max = ( max == null ? NaN : Number( max ) );
        this.min = ( min == null ? NaN : Number( min ) );
        this.step = ( step == null ? NaN : Number( step ) );
        if ( isNaN( this.max ) ) this.max = ControllerNumberInput.DEFAULT_MAX;
        if ( isNaN( this.min ) ) this.min = ControllerNumberInput.DEFAULT_MIN;
        if ( isNaN( this.step ) ) this.step = ControllerNumberInput.DEFAULT_STEP;

        const val = ( inputeValue == "" ? NaN : Number( inputeValue ) );
        if ( isNaN( val ) || val < this.min || val > this.max )
            this.inputField.value = this.min + '';

        // this, for a click event:
        if (currentPageSite !== 'warenkorb.htm' && currentPageSite !== 'warenkorb_gast.htm') this.onClickEvent(plusButton, minusButton, this.inputField);
        else this.onClickEventBasket(plusButton, minusButton, this.inputField);




        // or this, for mousedown/up events
        // plusButton.addEventListener('mousedown', this.startPlus.bind(this));
        // minusButton.addEventListener('mousedown', this.startMinus.bind(this));
        // document.addEventListener('mouseup', ()=> {
        //     this.stopPlus();
        //     this.stopMinus();
        // });
    }

    /** PLUS */
    private startPlus(): void {
        this.plus();
        this.plusInterval = setInterval( this.plus.bind(this), 500 );
    }

    private stopPlus(): void {
        clearInterval( this.plusInterval );
        this.plusInterval = 0;
    }

    private plus(): void {
        const val: number = Number( this.inputField.value );
        if ( val + this.step <= this.max ) {
            this.inputField.value =  val + this.step + '';
        }
    }

    /** MINUS */
    private startMinus(): void {
        this.minus();
        this.minusInterval = setInterval( this.minus.bind(this), 500 );
    }

    private stopMinus(): void {
        clearInterval( this.minusInterval );
        this.minusInterval = 0;
    }

    private minus(): void {
        const val: number = Number( this.inputField.value );
        if ( ControllerNumberInput.OVERRIDE_MIN ) {
            if ( val - this.step >= 0 ) {
                this.inputField.value = val - this.step + '';
            }
        }
        else {
            if ( val - this.step >= this.min ) {
                this.inputField.value = val - this.step + '';
            }
        }
    }

    private onClickEvent(plusButton:HTMLSpanElement, minusButton:HTMLSpanElement, inputField:HTMLInputElement):void {
        plusButton.addEventListener('click', ()=> {
            const inputeValue:number =  Number(inputField.value);
            if ( inputeValue + this.step <= this.max ) {
                inputField.value =  inputeValue + this.step + '';
            }
        });
        minusButton.addEventListener('click', ()=> {
            const inputeValue:number =  Number(inputField.value);
            if ( ControllerNumberInput.OVERRIDE_MIN ) {
                if ( inputeValue - this.step >= 0 ) {
                    inputField.value = inputeValue - this.step + '';
                }
            }
            else {
                if ( inputeValue - this.step >= this.min ) {
                    inputField.value = inputeValue - this.step + '';
                }
            }
        });
        inputField.addEventListener('input', ()=> {
            if ( this.max !== Infinity) {
                if ( Number( inputField.value ) > this.max ) {
                    inputField.value = this.max + '';
                }
            }
            // If Letters entered.
            if ( inputField.value === "" ) {
                inputField.value = 1 + '';
            }
        });
    }


    private onClickEventBasket(plusButton:HTMLSpanElement, minusButton:HTMLSpanElement, inputField:HTMLInputElement):void {
       // Event-Handler für Step-Anpassung
        function handleStep(isIncrement:boolean, button:HTMLElement) {
            if (this.timeoutTimer) {
                clearTimeout(this.timeoutTimer);
                this.timeoutTimer = null;
            }

            const inputValue = Number(inputField.value);
            const step = this.step;
            const max = this.max;
            const min = this.min;

            let newValue = inputValue;

            if (isIncrement) {
                if (inputValue + step <= max) {
                    newValue = inputValue + step;
                }
            } else {
                if (ControllerNumberInput.OVERRIDE_MIN) {
                    if (inputValue - step >= 0) {
                        newValue = inputValue - step;
                    }
                } else {
                    if (inputValue - step >= min) {
                        newValue = inputValue - step;
                    }
                }
            }

            inputField.value = newValue.toString();
            this.checkInputWithBasket(button);
        }

        // Event-Listener für Plus/Minus-Click
        plusButton.addEventListener('click', () => {
            handleStep.call(this, true, plusButton);
        });

        minusButton.addEventListener('click', () => {
            handleStep.call(this, false, minusButton);
        });

        // Enter / Space Support für Tastaturbedienung
        function handleKeyPress(e:KeyboardEvent, isIncrement:boolean, button:HTMLElement) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleStep.call(this, isIncrement, button);
            }
        }

        plusButton.addEventListener('keydown', (e) => {
            handleKeyPress.call(this, e, true, plusButton);
        });

        minusButton.addEventListener('keydown', (e) => {
            handleKeyPress.call(this, e, false, minusButton);
        });

        this.inputField.addEventListener('input', ()=> {
            if (this.timeoutTimer) {
                clearTimeout(this.timeoutTimer);
                this.timeoutTimer = null;
            }
            // Catch empty input and abnormal large numbers
            if (this.inputField.value === '' || this.inputField.value.length > 4) return;
            // Maximum nicht überstreitbar
            if ( this.max !== Infinity) {
                if ( Number( this.inputField.value ) > this.max ) {
                    this.inputField.value = this.max+ '';
                }
            }

            this.checkInputWithBasket( this.inputField );
        });

    }

    /**
     * @description Checking if config 'input_with_basket' exists and is true, then we add a timeout function to update the basket on the spot
     * @param currentlyUsedInput plus or minus button
     * @returns void
     */
    private checkInputWithBasket(currentlyUsedInput:HTMLElement):void {
        const inputWithBasket: Boolean = this.getModule().getConfig( "on_spot_basket_update" ); // getting on_spot_basket_update
        if ( !inputWithBasket || inputWithBasket === false  ) return null; // if the config doesn't exist or is false stop here
        this.timeoutTimer = setTimeout( ()=> this.sendForm(currentlyUsedInput), 1000); // else we add a timeout function onto the + and - buttons
        // 1000 could be done via a config var too
    }

    /**
     * @description updating the baskets content
     * @param currentlyUsedInput + or - button
     * @returns void
     */
    private sendForm(currentlyUsedInput:HTMLElement):void {
        // making sure we do have the a form that we submit, if not return early
        let basketForm: HTMLFormElement = currentlyUsedInput.closest('#form_listing') as HTMLFormElement;
        if ( ! basketForm ) basketForm = currentlyUsedInput.closest('form');
        if ( ! basketForm ) return null;

        const inputValue:HTMLInputElement = currentlyUsedInput.parentElement.querySelector('input'); // getting the input field of the currently used button
        const art_id:string = inputValue.getAttribute('data-ez-artid'); // getting the article ID
        const quantity: string = inputValue.value; // quantity.

        if ( quantity === '0') basketForm.submit(); // submit early => we deleted the article and reload the page

        // building url for the new basket
        const url: string = '/4DCGI/ezshop?action=JSON_addToKorb' + '&sKontaktID=' + modules.getKontaktID() + '&sKontaktKEY=' + modules.getKontaktKey() + '&sTICKCOUNT=' + modules.getTickcount() + `&artid=${art_id}&menge=${quantity}`;

        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            // Process the received data
            console.log(data);
            this.processSums( data, basketForm );
        })
        .catch(error => {
            // Handle any errors that occurred during the fetch request
            console.error('Error:', error);
        });
    }

    /**
     * @description Succesfully updated the basket, overwriting the html text
     * @param response json data
     * @param currentForm the form element of the article
     */
    private processSums( response: any, currentForm:HTMLFormElement ): void {

        // when we have the node
        if ( response.warenkorb_arts !== undefined ) {
            const output: NodeListOf<HTMLSpanElement> = document.querySelectorAll( "#basket_amount" );

            for ( let i: number = 0; i < output.length; i++ ) {
                output[i].innerHTML = response.warenkorb_arts.toString();
            }
            // HTML overwriting
            if ( currentPageSite == "warenkorb.htm" || currentPageSite == "warenkorb_gast.htm" ) {
                const sumBasketNet = response.sum_basket_net; // Summe Warenkorb Netto
                const freightNet = response.freight_net;
                const freight = response.freight; // Frachtkosten Brutto
                const sumIncludeTax = response.sum_includetax; // Summe mit Steuern
                const sumNet = response.sum_net; // Summe ohne Steuern
                const sumTaxFull = response.sum_tax_full; // Summe der Steuern (voll)
                const sumTaxHalf = response.sum_tax_half; // Summe der Steuern (halb)
                const articlePrice = response.position_summe_txt; // Summe des Artikels
                const sumBasketBrut = response.warenkorb_sum; // Warenkorbssumme brutto ohne Versand
                const bruttoGewicht = response.bruttogewicht; // Bruttogewicht Warenkorb
                const basisPreis = response.basispreis;
                const sonderpreis = response.sonderpreis;
                const grundPreis = response.grundpreis;
                const normalPreis = response.normalpreis;

                /******  Get the HTML Element to Refresh */
                const Element_CartSum: NodeListOf<HTMLElement> =        document.querySelectorAll( '#cart_sum' ).length > 0         ? document.querySelectorAll( '#cart_sum' )      : document.querySelectorAll( '.cart_sum' );
                const Element_FreightNet: NodeListOf<HTMLElement> =     document.querySelectorAll( '#freight_net' ).length > 0      ? document.querySelectorAll( '#freight_net' )   : document.querySelectorAll( '.freight_net' );
                const Element_freightSum: NodeListOf<HTMLElement> =     document.querySelectorAll( '#freight_sum' ).length > 0      ? document.querySelectorAll( '#freight_sum' )   : document.querySelectorAll( '.freight_sum' );
                const Element_SumNet: NodeListOf<HTMLElement>     =     document.querySelectorAll( '#sum_net' ).length > 0          ? document.querySelectorAll( '#sum_net' )       : document.querySelectorAll( '.sum_net' );
                const Element_SumTaxFull: NodeListOf<HTMLElement> =     document.querySelectorAll( '#sum_tax_full' ).length > 0     ? document.querySelectorAll( '#sum_tax_full' )  : document.querySelectorAll( '.sum_tax_full' );
                const Element_SumTaxHalf: NodeListOf<HTMLElement> =     document.querySelectorAll( '#sum_tax_half' ).length > 0     ? document.querySelectorAll( '#sum_tax_half' )  : document.querySelectorAll( '.sum_tax_half' );
                const Element_SumInclTax: NodeListOf<HTMLElement> =     document.querySelectorAll( '#sum_incl_tax' ).length > 0     ? document.querySelectorAll( '#sum_incl_tax' )  : document.querySelectorAll( '.sum_incl_tax' );
                const Element_CurrentArticle: NodeListOf<HTMLElement> = currentForm.querySelectorAll('#ez_sum').length > 0          ? currentForm.querySelectorAll('#ez_sum')       :  currentForm.querySelectorAll( '.ez_sum');
                const Element_SumExclusiveFraight: NodeListOf<HTMLElement> = document.querySelectorAll( '#ez_warenkorb_sum' ).length > 0  ? document.querySelectorAll( '#ez_warenkorb_sum' ) : document.querySelectorAll( '.ez_warenkorb_sum');
                const Element_BruttoGewicht: NodeListOf<HTMLElement> = document.querySelectorAll( '#ez_bruttogewicht').length > 0   ? document.querySelectorAll( '#ez_bruttogewicht') : document.querySelectorAll('.ez_bruttogewicht');

                if ( Element_CartSum ) Element_CartSum.forEach( ele => this.setInnerAmount (ele, sumBasketNet ) );
                if ( Element_FreightNet ) Element_FreightNet.forEach( ele => this.setInnerAmount (ele, freightNet ) );
                if ( Element_freightSum ) Element_freightSum.forEach( ele => this.setInnerAmount (ele, freight ) );
                if ( Element_SumNet ) Element_SumNet.forEach( ele => this.setInnerAmount (ele, sumNet ) );
                if ( Element_SumTaxFull ) Element_SumTaxFull.forEach( ele => this.setInnerAmount ( ele, sumTaxFull ) );
                if ( Element_SumTaxHalf ) Element_SumTaxHalf.forEach( ele => this.setInnerAmount (ele, sumTaxHalf ) );
                if ( Element_SumInclTax ) Element_SumInclTax.forEach( ele => this.setInnerAmount (ele, sumIncludeTax ) );
                if ( Element_CurrentArticle) Element_CurrentArticle.forEach( ele => this.setInnerAmount( ele, articlePrice ));
                if ( Element_SumExclusiveFraight ) Element_SumExclusiveFraight.forEach( ele => this.setInnerAmount( ele, sumBasketBrut  ));
                if ( Element_BruttoGewicht ) Element_BruttoGewicht.forEach( ele => this.setInnerAmount( ele, bruttoGewicht, 'kg'));

                if ( this.getModule().getConfig( "GA_Trigger" ) ) {
                    const basketResponseTransmitter = document.getElementById('basketResponseTransmitter');
                    if ( basketResponseTransmitter ) {
                        basketResponse = response;
                        basketResponseTransmitter.click();
                    }
                }
            }
        }
    }

    /**
     * @description helper method, making sure we have the correct currency in use
     * @param element element, that will get overwritten
     * @param value amount.
     * @param currency currenty.
     */
    private setInnerAmount(element:any, value:any, currency:any = sWaehrnam):void {
        // new conf: currency_in_front: false -> setting the currency after the amount
        const currencyInFront: boolean | null | undefined = this.getModule().getConfig( "currency_in_front" );
        if ( currencyInFront !== undefined && !currencyInFront ) {
            if (currency === "EUR") element.innerHTML = value + "&nbsp;&euro;";
            else  element.innerHTML = value + "&nbsp;" + currency;
            return;
        }

        if (currency === "EUR") element.innerHTML = "&euro;&nbsp;" + value;
        else  element.innerHTML = currency + "&nbsp;" + value;
    }
}